import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/transitions.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';
import './i18n';
import { installRestartRetry } from './utils/restartRetry';
import { getLanguage } from './utils/locale';

// Pages that call the default axios instance directly get the same restart tolerance
installRestartRetry(axios);
// ...and send the UI language, so server messages come back in it
axios.interceptors.request.use((config) => {
  config.headers['Accept-Language'] = getLanguage();
  return config;
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
